import { render, staticRenderFns } from "./AssetConfigurationForm.vue?vue&type=template&id=0fa83640&"
import script from "./AssetConfigurationForm.vue?vue&type=script&lang=ts&"
export * from "./AssetConfigurationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports